module.exports = __webpack_public_path__ + "static/img/405.ecb6d67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/191007/405.jpg
// module id = je+U
// module chunks = 0